import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as Leaflet from 'leaflet';
import 'leaflet.markercluster';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/services';
import { CatalogService } from 'src/app/services/catalog.service';
import { ContractService } from 'src/app/services/contract.service';
import { DateService } from 'src/app/services/date.service';
import { MapService } from 'src/app/services/map.service';
import { ProjectService } from 'src/app/services/project.service';
import { ServiceOrderService } from 'src/app/services/service-order.service';
import { ToastService } from 'src/app/services/toast.service';
import { SignalElement, SignalsElement } from 'src/app/utils/signalsElements';
import { PdfLine, PdfMarker } from 'src/app/components/pdf-viewer/pdf-viewer.component';
import { svgElement } from 'src/dictionaries/svg-sign';
import {
  ActionEnum,
  ComplementInformationEnum,
  ComplementInformationSignEnum,
  DimensionInformationEnum,
  ItemUnitEnum,
  SignalingHistoryActionMadeOnEnum,
  SignalingTypeEnum,
  TaskTypeEnum,
  VerticalGroupTypeEnum,
  VerticalSignalingEnum,
  VerticalSignalizationTypeEnum,
} from 'src/enumerators';
import {
  Contract,
  ContractHorizontalItem,
  ContractVerticalItemSign,
  DeviceSignaling,
  HorizontalSignaling,
  ServiceOrder,
  TrafficSign,
  User,
  VerticalSignaling,
  VerticalTrafficSignaling,
} from 'src/models';
import {
  Project,
  ProjectDeviceSignaling,
  ProjectFile,
  ProjectHistory,
  ProjectHorizontalSignaling,
  ProjectSupport,
  ProjectTrafficSign,
} from 'src/models/project';

@Component({
  selector: 'app-resume-project',
  templateUrl: './resume-project.component.html',
  styleUrls: ['./resume-project.component.css'],
})
export class ResumeProjectComponent implements OnInit {
  editMode: boolean = false;
  hashId: string = '';
  currentUser: User;
  mapZoom: boolean = true;
  update: boolean = false;
  loading: boolean = true;

  map: Leaflet.Map;
  layer: Leaflet.LayerGroup = Leaflet.markerClusterGroup({
    showCoverageOnHover: false,
    iconCreateFunction: function (cluster) {
      return Leaflet.divIcon({ html: "<div class='icon-cluster'><h4>" + cluster.getChildCount() + '</h4></div>' });
    },
  });
  layerProjectsSignalings: Leaflet.LayerGroup = new Leaflet.LayerGroup();

  mapModal: Leaflet.Map;
  layerModal: Leaflet.LayerGroup = Leaflet.markerClusterGroup({
    showCoverageOnHover: false,
    iconCreateFunction: function (cluster) {
      return Leaflet.divIcon({ html: "<div class='icon-cluster'><h4>" + cluster.getChildCount() + '</h4></div>' });
    },
  });
  signs: {
    vertical: Set<VerticalTrafficSignaling>;
    horizontal: Set<HorizontalSignaling>;
    device: Set<DeviceSignaling>;
  } = {
      vertical: new Set(),
      horizontal: new Set(),
      device: new Set(),
    };
  projectImages: Array<any>; // imagens do projeto
  displayMasterSigns: Array<any> = []; // lista de todas as sinalizações do arquivo mestre
  masterSigns: Array<any> = []; // sinalizações que possuem arquivo mestre
  selectedFile: any = ''; // Imagem Selecionada no Arquivo Mestre
  mapArqMaster: boolean = false; // false é map, true é arquivo mestre
  listFiles = []; // Lista com as Imagens do Projeto
  verticalGroupState: Array<boolean> = [];
  horizontalGroupState: Array<boolean> = [];
  deviceGroupState: Array<boolean> = [];
  selectedPointA = { posX: 0, posY: 0, fileDimensions: '0x0' }; // Ponto A
  selectedPointB = { posX: 0, posY: 0, fileDimensions: '0x0' }; // Ponto B
  pointsList: Array<{ posX: number; posY: number; fileDimensions: string; svg: string; signCode: string; master?: any; point?: 'A' | 'B' }> = [];
  // Markers sobre PDF (coordenadas normalizadas por página) + mapa id->registro.
  pdfPointsList: PdfMarker[] = [];
  pdfLinesList: PdfLine[] = [];
  pdfMasterById: { [id: string]: any } = {};
  complementInformationType = ComplementInformationEnum;
  verticalGroupTypeEnum = VerticalGroupTypeEnum;
  itemUnitEnum = ItemUnitEnum;
  actionEnum = ActionEnum;
  signalingHistoryActionMadeOnEnum = SignalingHistoryActionMadeOnEnum;
  verticalSignType = VerticalSignalizationTypeEnum;
  verticalSign = VerticalSignalingEnum;
  dimensionType = DimensionInformationEnum;
  signTypeEnum = SignalingTypeEnum;

  projectTrafficSigns = [];
  projectHorizontalSigns = [];

  // Modal de serviços
  serviceOrderList: ServiceOrder[];
  modalSignList = {
    projectTrafficSigns: [],
    projectSupports: [],
    projectHorizontalSignalings: [],
    projectDeviceSignalings: [],
  };
  modalCheckState: { vertical: boolean; horizontal: boolean; device: boolean } = {
    vertical: true,
    horizontal: true,
    device: true,
  };
  modalSelectedOption: number = 0; // OS nova, Tarefa Independente e O.S existente
  selectedServiceOrderId: string;

  // Referencia do modal
  modalRef: BsModalRef;

  signalsElements: SignalElement[] = Object.values(SignalsElement); // Sinalizações para o SVG
  amoutType = [0, 0]; // O valor de cada um dos filtros para somar ao total depois
  blockSubmit = false;

  modalTaskState;
  displayPage = false; // variavel que sabe se a página é display ou não

  masterFile: ProjectFile; // arquivo mestre de projetos
  // PDF é renderizado via <app-pdf-viewer> (pdfjs em canvas); markers visuais
  // não se aplicam (overlay depende das dimensões da imagem original).
  isMasterFilePdf = false;
  masterFilePdfSrc: string | null = null;
  // Zoom do arquivo mestre quando é imagem (JPG/PNG). PDF tem zoom interno.
  // Aplicado via transform: scale() num wrapper que envolve a img + markers,
  // assim os pontos plotados acompanham a escala. O container externo já tem
  // overflow auto para permitir scroll quando o conteúdo extrapola.
  masterImageZoom = 1;
  masterImgLoaded = false; // controla o loading enquanto a imagem do arquivo-mestre carrega
  private readonly _zoomMin = 0.5;
  private readonly _zoomMax = 4;
  private readonly _zoomStep = 0.25;
  // Estado do pan (click-and-drag) sobre o arquivo mestre. Manipula scrollLeft
  // / scrollTop do container, então funciona em qualquer nível de zoom — quando
  // a imagem é maior que o container, o usuário arrasta para revelar as bordas.
  isPanningMaster = false;
  private _panStartX = 0;
  private _panStartY = 0;
  private _panScrollLeft = 0;
  private _panScrollTop = 0;
  modalSignFilterCode: string; // recebe signCode para filtrar mapa ou arq mestre

  mapReady: EventEmitter<boolean> = new EventEmitter(true); // emitir quando o mapa está pronto para inicializar

  @Output() newController = new EventEmitter<string>();
  @Input() projectBody: Project;
  @Input() uploadedFiles: any;
  @Input() contract: Contract;

  constructor(
    private _projectService: ProjectService,
    private _toastService: ToastService,
    private _router: Router,
    private _activedRoute: ActivatedRoute,
    private _contractService: ContractService,
    public _auth: AuthService,
    private _catalog: CatalogService,
    private _map: MapService,
    private _dateService: DateService,
    private _modalService: BsModalService,
    private _serviceOrderService: ServiceOrderService,
  ) { }

  ngOnInit() {
    this.subscribeMap();
    this.currentUser = this._auth.loggedUser;
    this.displayPage =
      this._activedRoute.snapshot?.url.length > 1 && this._activedRoute.snapshot?.url[1]?.path == 'display';

    this._activedRoute.params.subscribe((res) => {
      if (res.id) {
        this.hashId = res.id;
        this.update = true;
        if (!this.projectBody?.id) {
          this.editMode = true;
          this._projectService.getProject(this.hashId).subscribe(
            (next: Project) => {
              this.projectBody = next;
              if (this.displayPage) {
                this._projectService.getProjectHistory(this.projectBody).subscribe((res: Array<ProjectHistory>) => {
                  this.projectBody.history = res;
                  this._contractService.listAllWorkspaceUsers().subscribe((res: any) => {
                    this.projectBody.createdByMember = res.members.find(
                      (member) => member.id == this.projectBody.createdByMemberId,
                    );

                    this.projectBody.history.forEach((history: ProjectHistory) => {
                      history.member = res.members.find((member) => member.id == history.memberId);
                    });

                    this.getMasterFile();
                  });

                  this.getSigns(this.layer);
                  this.uploadedFiles = this.projectBody?.projectFiles;
                });
              }

              this._contractService.getContract(this.projectBody?.contractId).subscribe((res: any) => {
                this.contract = res;

                // Pegar os substrato em traffic
                this.projectBody.projectTrafficSigns.forEach((traffic: ProjectTrafficSign) => {
                  this.contract.verticalGroups.forEach((group) => {
                    if (group.groupType == VerticalGroupTypeEnum.RoadSign) {
                      group.verticalItems.forEach((item: ContractVerticalItemSign) => {
                        if (item.id == traffic.contractVerticalItemId) {
                          traffic.contractVerticalItem = item;
                        }
                      });
                    }
                  });
                });

                // Pegar o material aplicado em Horizontal
                this.projectBody.projectHorizontalSignalings.forEach((traffic: ProjectHorizontalSignaling) => {
                  this.contract.horizontalGroups.forEach((group) => {
                    group.horizontalItems.forEach((item: ContractHorizontalItem) => {
                      if (item.id == traffic.contractHorizontalItemId) {
                        traffic.contractHorizontalItem = item;
                      }
                    });
                  });
                });

                this.projectTrafficSigns = this.setProjectGroupSigns(this.projectBody.projectTrafficSigns);
                this.projectHorizontalSigns = this.setProjectGroupSigns(this.projectBody.projectHorizontalSignalings);

                this.loading = false;
                this.mapReady.emit(true);
              });
            },
            (error) => {
              if (error.error?.message.includes('not found')) {
                this._toastService.showError('O projeto não foi encontrado!');
              } else {
                this._toastService.showError('Ocorreu um erro inesperado, tente novamente!');
              }
              this._router.navigate([`/projects/`]);
            },
          );
        }
        if (this.projectBody?.id) {
          this._contractService.listAllWorkspaceUsers().subscribe((res: any) => {
            this.projectBody.createdByMember = res.members.find(
              (member) => member.id == this.projectBody.createdByMemberId,
            );
            this.projectTrafficSigns = this.setProjectGroupSigns(this.projectBody.projectTrafficSigns);
            this.projectHorizontalSigns = this.setProjectGroupSigns(this.projectBody.projectHorizontalSignalings);
            this.loading = false;
          });
        }
      } else {
        this.calculateCost();
        this.projectTrafficSigns = this.setProjectGroupSigns(this.projectBody.projectTrafficSigns);
        this.projectHorizontalSigns = this.setProjectGroupSigns(this.projectBody.projectHorizontalSignalings);
        this.loading = false;
      }
    });
  }

  // Aguarda pipe finalizar para iniciar o mapa
  subscribeMap() {
    this.mapReady.subscribe((next) => {
      let coordinates = [];
      if (!next) return;
      this.map = this._map.initMap('project-map');
      this._map.initLayer(this.map, this.layer);
      this._map.initLayer(this.map, this.layerProjectsSignalings);

      this.projectBody.projectDeviceSignalings.forEach(element => {
        if (element?.locations?.length) {
          this.addProjectDeviceSignalingMarker(element);
          coordinates.push({ lat: element.locations[0], lng: element.locations[1] });
        }
      });

      this.projectBody.projectTrafficSigns.forEach(element => {
        if (element.latitude && element.longitude) {
          this.addProjectTrafficSignMarker(element);
          coordinates.push({ lat: element.latitude, lng: element.longitude });
        }
      });

      this.projectBody.projectHorizontalSignalings.forEach(element => {
        if (element.latitude && element.longitude) {
          this.addProjectHorizontalSignalingMarker(element)
          coordinates.push({ lat: element.latitude, lng: element.longitude });
        }
      });

      this.centralizeMap(coordinates);
      this.mapReady.unsubscribe();
    });
  }

  // Emite a variavel que controla a rota da página
  emitPageController(value: string) {
    this.newController.emit(value);
  }

  //Retorna uma lista com os tempos em anos, meses, dias, horas e minutos, e a diferença em milissegundos
  getRelativeTime(warranty, date) {
    return this._dateService.getRelativeTime(warranty, date);
  }

  calculateCost() {
    const projectDeviceSignalingsAmount = this.projectBody.projectDeviceSignalings.reduce((acc, current) => {
      return acc + (current.cost ?? 0);
    }, 0);

    const projectHorizontalSignalingsAmount = this.projectBody.projectHorizontalSignalings.reduce((acc, current) => {
      return acc + (current.cost ?? 0);
    }, 0);

    const projectTrafficSignsAmount = this.projectBody.projectTrafficSigns.reduce((acc, current) => {
      return acc + (current.cost ?? 0);
    }, 0);

    const projectSupportsAmount = this.projectBody.projectSupports.reduce((acc, current) => {
      return acc + (current.cost ?? 0);
    }, 0);

    this.projectBody.cost = projectDeviceSignalingsAmount + projectHorizontalSignalingsAmount + projectTrafficSignsAmount + projectSupportsAmount;
  };

  // Atualiza os itens do contrato na aplicação
  private updateApplied(applied: any, contractItem: any, type: SignalingTypeEnum) {
    switch (type) {
      case SignalingTypeEnum.Vertical:
        if (applied.supportMaterial) {
          delete applied['signaling'];
          applied['contractVerticalItem'] = contractItem;
          applied['supportMaterial'] = contractItem.supportMaterial;
        } else {
          if (!this.blockSubmit) this.blockSubmit = !applied['signaling'] ? true : false;
          applied['contractVerticalItem'] = contractItem;
          applied['roadSignSubstrateId'] = contractItem?.roadSignSubstrateId;
          applied['roadSignSubstrate'] = contractItem?.roadSignSubstrate;
          applied['roadSignFilmItems'] = [{ roadSignFilmId: contractItem?.roadSignFilmItems[0].roadSignFilmId }];
        }
        break;
      case SignalingTypeEnum.Horizontal:
        if (!this.blockSubmit) this.blockSubmit = !applied['signaling'] ? true : false;

        applied['roadSignMarkingPaintId'] = contractItem?.roadSignMarkingPaintId;
        applied['roadSignMarkingPaint'] = contractItem?.roadSignMarkingPaint;
        break;
      case SignalingTypeEnum.Device:
        applied['signaling'] = contractItem?.signaling;
        break;
    }
  }

  getSigns(layer) {
    this._catalog.getAllVerticalFromProject(this.hashId).subscribe((res: Array<VerticalSignaling>) => {
      var markersToCentralize = []
      res.forEach((element) => {
        if (element.verticalSignalingMasterFile.id) {
          this.masterSigns.push(element.verticalSignalingMasterFile);
        }

        element.trafficSigns.forEach((vertical: TrafficSign, index) => {
          element['useTraffic'] = index;
          const sign: VerticalTrafficSignaling = new VerticalTrafficSignaling(element);
          markersToCentralize.push([sign.lat, sign.lng])
          this.signs.vertical.add(sign);
          if (sign.order == 1) {
            this.addMarker(sign, layer);
          }
        });
      });
      this._catalog.getAllHorizontalFromProject(this.hashId).subscribe((res: Array<HorizontalSignaling>) => {
        res.forEach((element: HorizontalSignaling) => {
          if (element.horizontalSignalingMasterFile.id) {
            this.masterSigns.push(element.horizontalSignalingMasterFile);
          }
          markersToCentralize.push([element.locations[0].lat, element.locations[0].lng])
          if (element.locations[1]) markersToCentralize.push([element.locations[1].lat, element.locations[1].lng])
          this.signs.horizontal.add(element);
          this.addMarker(element, layer);
        });
        this._catalog.getAllDeviceFromProject(this.hashId).subscribe((res: Array<DeviceSignaling>) => {
          res.forEach((element: DeviceSignaling) => {
            if (element.deviceSignalingMasterFile.id) {
              this.masterSigns.push(element.deviceSignalingMasterFile);
            }
            markersToCentralize.push([element.locations[0].lat, element.locations[0].lng])
            if (element.locations[1]) markersToCentralize.push([element.locations[1].lat, element.locations[1].lng])
            this.signs.device.add(element);
            this.addMarker(element, layer);
          });
          this.map.fitBounds(markersToCentralize, { padding: [15, 15] })
          this.getMasterFile();
        });
      });
    });
  }

  stringToFloatFixed(string): string {
    const formatedValue = typeof string === 'number' ? string.toString().replace(' ', '') : string.replace(' ', '');
    let coefficient = Math.pow(10, 3);
    let number = Math.floor(parseFloat(formatedValue) * coefficient) / coefficient;

    let options = {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3,
      useGrouping: false,
    };
    return number.toLocaleString('pt-BR', options);
  }

  initMap() {
    this.map = this._map.initMap('mapContainer');
    this._map.initLayer(this.map, this.layer);
  }

  // POST criar projeto
  submitProject() {
    this.dismantleActivitiesProject();


    if (this.update) {
      this._projectService.updateProject(this.projectBody).subscribe(
        (next: Project) => {
          if (this.uploadedFiles.length) {
            this._projectService.uploadProjectFiles(this.uploadedFiles, this.hashId).subscribe(
              (res: any) => {
                for (let file of this.uploadedFiles) {
                  if (file.masterFile) {
                    const fileId = !!file.id
                      ? file.id
                      : res.files.find((f) => f.file.originalName == (file.file.name || file.file.originalName))
                        .projectFile.id;
                    this._projectService.updateMasterFile(next.id, fileId).subscribe();
                  }
                }
                this._toastService.showSuccess('Projeto editado com sucesso!');
                this._router.navigate(['/projects']);
              },
              (error) => {
                this._toastService.showError('Ocorreu um erro ao criar o Projeto');
              },
            );
          } else {
            this._toastService.showSuccess('Projeto editado com sucesso!');
            this._router.navigate(['/projects']);
          }
        },
        (error) => {
          this._toastService.showError('Ocorreu um erro ao criar o Projeto');
        },
      );
    } else {
      this._projectService.createProject(this.projectBody).subscribe(
        (next: Project) => {
          if (this.uploadedFiles.length) {
            this._projectService.uploadProjectFiles(this.uploadedFiles, next?.id).subscribe(
              (res: any) => {
                for (let file of this.uploadedFiles) {
                  if (file.masterFile) {
                    const fileId = !!file.id
                      ? file.id
                      : res.files.find((f) => f.file.originalName == (file.file.name || file.file.originalName))
                        .projectFile.id;
                    this._projectService.updateMasterFile(next.id, fileId).subscribe((fileRes) => { });
                  }
                }
                this._toastService.showSuccess('Projeto criado com sucesso!');
                this._router.navigate(['/projects']);
              },
              (error) => {
                this._toastService.showError('Ocorreu um erro ao criar o Projeto');
              },
            );
          } else {
            this._toastService.showSuccess('Projeto criado com sucesso!');
            this._router.navigate(['/projects']);
          }
        },
        (error) => {
          this._toastService.showError('Ocorreu um erro ao criar o Projeto');
        },
      );
    }
  }

  //Adiciona marcador no mapa
  addMarker(element, layer) {
    let markIcon = element['svg'];
    let iconSize = [40, 40];
    let latlng: [number, number];
    let mark;
    let content;
    if (element.type == SignalingTypeEnum.Vertical) {
      let classInternalCaption = `${element['signCode']}-40`;
      latlng = [element.lat, element.lng];
      let combined = element['combined'] ? true : false;
      mark = this._map.addMarker(
        latlng,
        layer,
        markIcon,
        {},
        false,
        false,
        iconSize[0],
        iconSize[1],
        combined,
        element['internalCaption'],
        classInternalCaption,
      );
      content = this._map.addPopup(element, 2);
      let popup = Leaflet.popup({ closeButton: false }).setContent(content);
      mark.bindPopup(popup);
    } else {
      if (element.type == SignalingTypeEnum.Device) {
        element.locations.forEach((location, index) => {
          latlng = [location['lat'], location['lng']];
          mark = this._map.addMarker(
            latlng,
            layer,
            markIcon,
            {},
            false,
            false,
            iconSize[0],
            iconSize[1],
            false,
            undefined,
            '',
          );
          content = this._map.addPopup(element, index);
          let popup = Leaflet.popup({ closeButton: false }).setContent(content);
          mark.bindPopup(popup);
        });
      } else {
        element.locations.forEach((location, index) => {
          latlng = [location['lat'], location['lng']];
          mark = this._map.addMarker(
            latlng,
            layer,
            markIcon,
            {},
            false,
            false,
            iconSize[0],
            iconSize[1],
            false,
            undefined,
            '',
          );
          content = this._map.addPopup(element, index);
          let popup = Leaflet.popup({ closeButton: false }).setContent(content);
          mark.bindPopup(popup);
        });
      }
    }
  }

  deleteProject() {
    this._activedRoute.params.subscribe((res) => {
      this._projectService.deleteProject(res.id).subscribe(
        (next) => {
          this._toastService.showSuccess('Projeto removido com sucesso!');
          this._router.navigate(['/projects']);
          this.modalRef.hide();
        },
        (error) => {
          this._toastService.showError('Não foi possível remover o projeto');
        },
      );
    });
  }

  goToEdition() {
    this._router.navigate([`/projects/new-project/${this.hashId}`]);
  }

  // abre modal
  openModal(template: TemplateRef<any>) {
    this.modalRef = this._modalService.show(template, {
      class: 'modal-dialog-centered modal-lg',
      backdrop: 'static',
    });
  }

  openLargeModal(template: TemplateRef<any>) {
    this.modalRef = this._modalService.show(template, {
      class: 'modal-dialog-centered modal-xl',
      backdrop: 'static',
    });

    // O template do modal é recriado a cada abertura com a primeira opção marcada; o estado tem que acompanhar
    this.modalSelectedOption = 0;
    this.modalCheckState = { vertical: true, horizontal: true, device: true };
    this.selectedServiceOrderId = '';

    this.modalSignList = {
      projectTrafficSigns: [],
      projectSupports: [],
      projectHorizontalSignalings: [],
      projectDeviceSignalings: [],
    };

    this._serviceOrderService.getOrders().subscribe((res: ServiceOrder[]) => (this.serviceOrderList = res));

    this.projectBody.projectTrafficSigns.forEach((sign) => {
      this.modalSignList.projectTrafficSigns.push(new ProjectTrafficSign(sign));
    });
    this.projectBody.projectSupports.forEach((sign) => {
      this.modalSignList.projectSupports.push(new ProjectSupport(sign));
    });
    this.projectBody.projectHorizontalSignalings.forEach((sign) => {
      this.modalSignList.projectHorizontalSignalings.push(new ProjectHorizontalSignaling(sign));
    });
    this.projectBody.projectDeviceSignalings.forEach((sign) => {
      this.modalSignList.projectDeviceSignalings.push(new ProjectDeviceSignaling(sign));
    });
    this.pointsList = [];
    this.pdfPointsList = [];
    this.pdfLinesList = [];
    this.pdfMasterById = {};
    this.masterSigns.forEach((master) => {
      this.GetMarkers(master);
    });
    this.centerImage();
  }
  centerImage() {
    const image = new Image();
    image.src = this.masterFile as any;
    const elementImg = document.getElementById('master-file-edit') || document.getElementById('view-master-on-resume');
    image.onload = () => {
      elementImg.scrollTop = elementImg.clientHeight;
    };
  }

  downloadFile(fileId: string) {
    this._projectService.downloadProjectFile(fileId).subscribe((res) => {
      window.open(res.url);
    });
  }

  // Handle do switch: Mapa <-> Arquivo-mestre
  changeMarkerView(type: 'file' | 'map') {
    if (type == 'file') {
      this.mapArqMaster = true;
    } else {
      this.mapArqMaster = false;
    }
  }

  //Obter as Imagens do Projeto
  getMasterFile() {
    const file = this.projectBody.projectFiles.find((pFile) => pFile.masterFile == true);
    if (!file) return;

    // getMasterFile() é chamado mais de uma vez durante o carregamento (uma vez
    // direto e outra no fim do fluxo de signs, quando masterSigns já está
    // preenchido). A URL assinada muda a cada request, então refazer o fetch
    // reatribuiria masterFile, resetando o loading e podendo travar o spinner
    // pra sempre (o <img> recarrega mas o (load) pode não voltar). Buscamos a
    // URL só na primeira vez; nas chamadas seguintes apenas replotamos os
    // marcadores (masterSigns pode ter sido preenchido depois do fetch).
    if (this.masterFile) {
      this.refreshMasterFileOverlay();
      return;
    }

    // previewProjectFile usa signedURL sem Content-Disposition attachment,
    // pra renderizar inline em <iframe>/<img> em vez de forçar download.
    this._projectService.previewProjectFile(file?.id).subscribe((res: any) => {
      // Preferimos mime type quando disponível pra não tentar iframe em
      // arquivos que vão dar S3 NoSuchKey (o iframe exibe o XML feio).
      const mime = String((file as any)?.file?.mimeType ?? '');
      const isPdf = mime
        ? /pdf$/i.test(mime)
        : /\.pdf(\?|$)/i.test(String(res.url ?? ''));
      // Enquanto a imagem não carrega, exibe o loading (só imagem; PDF tem seu
      // próprio loading no app-pdf-viewer).
      if (!isPdf) this.masterImgLoaded = false;
      this.masterFile = res.url;
      this.isMasterFilePdf = isPdf;
      this.masterFilePdfSrc = isPdf ? String(res.url) : null;
      if (!isPdf) this.centerImage();
      this.refreshMasterFileOverlay();
    });
  }

  setMasterSigns(fileId: string, div: any) {
    this.pointsList = [];
    this.displayMasterSigns = [];
    this.selectedFile = this.projectImages.find((img) => {
      return img.projectFileId == fileId;
    });
    this.masterSigns.forEach((master) => {
      if (master.projectFileId == fileId) {
        this.GetMarkers(master);
        master['pointA'] = this.selectedPointA;
        master['pointB'] = this.selectedPointB;
        this.displayMasterSigns.push(master);
      }
    });
  }

  //Obter Marcadores Caso Exista
  GetMarkers(masterFile) {
    const file = masterFile.projectFile;
    if (!file) return;

    const isPdfPlacement = masterFile?.locations?.[0]?.page != null;

    // Resolve o signCode (assíncrono) e então plota — para imagem precisa das
    // dimensões originais; para PDF usa coordenadas normalizadas direto.
    const withSignCode = (signCode: string) => {
      if (isPdfPlacement) {
        this.setPdfPoints(masterFile, signCode);
        return;
      }
      const image = new Image();
      image.src = this.masterFile as any;
      image.onload = () => this.setPoints(masterFile, image.width, image.height, signCode);
    };

    if (masterFile.verticalSignalingId) {
      this._catalog.getVertical(masterFile.verticalSignalingId).subscribe((res: any) => {
        withSignCode(res.trafficSigns[0].signCode);
      });
    } else if (masterFile.horizontalSignalingId) {
      this._catalog.getHorizontal(masterFile.horizontalSignalingId).subscribe((res: any) => {
        withSignCode(res.signCode);
      });
    } else {
      this._catalog.getDevice(masterFile.deviceSignalingId).subscribe((res: any) => {
        withSignCode(res.signCode);
      });
    }
  }

  // Plota markers de PDF (coordenadas normalizadas 0..1 + página).
  setPdfPoints(masterFile, signCode) {
    const loc = masterFile['locations'][0];
    const svg = svgElement.Signaling[signCode];
    masterFile['__svg'] = svg;
    masterFile['__signCode'] = signCode;
    if (masterFile.id) this.pdfMasterById[masterFile.id] = masterFile;
    // Rótulos A/B só quando a sinalização tem os dois pontos (linha), pra
    // distinguir as pontas; ponto único dispensa a letra.
    const hasBoth = loc?.pointA?.x != null && loc?.pointB?.x != null;
    if (loc?.pointA?.x != null) {
      this.pdfPointsList = [...this.pdfPointsList, { page: loc.page, x: loc.pointA.x, y: loc.pointA.y, svg, id: masterFile.id, label: hasBoth ? 'A' : undefined }];
    }
    if (loc?.pointB?.x != null) {
      this.pdfPointsList = [...this.pdfPointsList, { page: loc.page, x: loc.pointB.x, y: loc.pointB.y, svg, id: masterFile.id, label: hasBoth ? 'B' : undefined }];
    }
    // Linha tracejada ligando A e B da mesma sinalização.
    if (loc?.pointA?.x != null && loc?.pointB?.x != null) {
      this.pdfLinesList = [...this.pdfLinesList, { page: loc.page, x1: loc.pointA.x, y1: loc.pointA.y, x2: loc.pointB.x, y2: loc.pointB.y }];
    }
  }

  // Centro (px) de um marker sobre a div de exibição (mesma matemática do
  // GetMarkerPosition, sem o offset do ícone).
  private markerCenter(div: any, marker: any): { x: number; y: number } {
    const divWidth = div.offsetWidth;
    const divHeight = div.offsetHeight;
    const fileWidth = +marker.fileDimensions.split('x')[0];
    const fileHeight = +marker.fileDimensions.split('x')[1];
    const xScale = divWidth / fileWidth;
    const yScale = divHeight / fileHeight;
    let scale = 0, xOffset = 0, yOffset = 0;
    if (xScale > yScale) { scale = xScale; yOffset = (divHeight - fileHeight * scale) / 2; }
    else { scale = yScale; xOffset = (divWidth - fileWidth * scale) / 2; }
    return { x: marker.posX * scale + xOffset, y: marker.posY * scale + yOffset };
  }

  // Cache de "quais master têm os dois pontos plotados", reconstruído sob
  // demanda quando pointsList muda (nova referência após reset em
  // refreshMasterFileOverlay/setMasterSigns). Evita recalcular O(n) por ponto
  // (virando O(n²) no total) a cada ciclo de change-detection.
  private _bothPointsCache: { forList: typeof this.pointsList; mastersWithBoth: Set<any> } | null = null;

  private _bothPointsMastersSet(): Set<any> {
    if (this._bothPointsCache?.forList === this.pointsList) return this._bothPointsCache.mastersWithBoth;

    const hasA = new Set<any>();
    const hasB = new Set<any>();
    for (const p of this.pointsList) {
      if (p.point === 'A') hasA.add(p.master);
      if (p.point === 'B') hasB.add(p.master);
    }
    const mastersWithBoth = new Set<any>([...hasA].filter((master) => hasB.has(master)));
    this._bothPointsCache = { forList: this.pointsList, mastersWithBoth };
    return mastersWithBoth;
  }

  // A sinalização tem os dois pontos (A e B) plotados sobre a imagem?
  private hasBothPoints(master: any): boolean {
    return this._bothPointsMastersSet().has(master);
  }

  // Mostra o rótulo A/B do marcador (imagem) só quando há os dois pontos, pra
  // distinguir início e fim; ponto único não precisa de letra.
  showPointLabel(point: { point?: 'A' | 'B'; master?: any }): boolean {
    return !!point.point && this.hasBothPoints(point.master);
  }

  // Linhas tracejadas A-B (imagem), agrupando pontos por sinalização.
  // Retorna null quando vazio: um array vazio é truthy, então *ngIf="getImageLines(...) as lines"
  // sempre renderizava o <svg> mesmo sem nenhuma linha.
  getImageLines(div: any): Array<{ x1: number; y1: number; x2: number; y2: number }> | null {
    const byMaster = new Map<any, { A?: any; B?: any }>();
    for (const p of this.pointsList) {
      if (!p.master) continue;
      const key = p.master;
      if (!byMaster.has(key)) byMaster.set(key, {});
      byMaster.get(key)![p.point] = p;
    }
    const lines: Array<{ x1: number; y1: number; x2: number; y2: number }> = [];
    byMaster.forEach(({ A, B }) => {
      if (A && B) {
        const a = this.markerCenter(div, A);
        const b = this.markerCenter(div, B);
        lines.push({ x1: a.x, y1: a.y, x2: b.x, y2: b.y });
      }
    });
    return lines.length ? lines : null;
  }

  // Retorna qual é o tipo da informação complementar sabendo qual é o tipo da placa WARNING/REGULATION
  complementType(applied): ComplementInformationSignEnum {
    if (applied.complementInformationType == ComplementInformationEnum.Additional) {
      if (applied.signalizationType == VerticalSignalizationTypeEnum.Warning) {
        return ComplementInformationSignEnum.AdditionalWarning;
      } else {
        return ComplementInformationSignEnum.AdditionalRegulation;
      }
    } else {
      if (applied.signalizationType == VerticalSignalizationTypeEnum.Warning) {
        return ComplementInformationSignEnum.IncorporatedWarning;
      } else {
        return ComplementInformationSignEnum.IncorporatedRegulation;
      }
    }
  }

  setPoints(masterFile, fileWidth, fileHeight, signCode) {
    masterFile['__svg'] = svgElement.Signaling[signCode];
    masterFile['__signCode'] = signCode;
    const selectedPointA = {
      posX: masterFile['locations'][0]['pointA']['x'] || 0,
      posY: masterFile['locations'][0]['pointA']['y'] || 0,
      fileDimensions: fileWidth + 'x' + fileHeight,
      svg: svgElement.Signaling[signCode],
      signCode: signCode,
      master: masterFile,
      point: 'A' as const,
    };

    const selectedPointB = {
      posX: masterFile['locations'][0]['pointB']['x'] || 0,
      posY: masterFile['locations'][0]['pointB']['y'] || 0,
      fileDimensions: fileWidth + 'x' + fileHeight,
      svg: svgElement.Signaling[signCode],
      signCode: signCode,
      master: masterFile,
      point: 'B' as const,
    };
    this.pointsList.push(selectedPointA);
    if (masterFile['locations'][0]['pointB']['x']) this.pointsList.push(selectedPointB);
  }

  // ===== Reposicionamento de sinalização no arquivo-mestre (página do projeto) =====
  repositionMaster: any = null; // registro *SignalingMasterFile em edição
  repositionSignType: SignalingTypeEnum | null = null;
  repositionSignSvg: string | undefined; // ícone da sinalização em reposicionamento
  repositionSignCode = ''; // código da sinalização em reposicionamento (p/ nome)
  repositionReferences: Array<{ locations: any; svg: string }> = []; // demais no mesmo arquivo-mestre
  repositionData: any = null; // { id?, projectFileId, locations } emitido pelo app-master-file
  repositionModalRef: BsModalRef;
  @ViewChild('repositionModal') repositionModal: TemplateRef<any>;

  // Descobre o tipo (H/V/D) a partir do registro de arquivo-mestre.
  private getSignTypeFromMaster(master: any): SignalingTypeEnum {
    if (master?.verticalSignalingId) return SignalingTypeEnum.Vertical;
    if (master?.horizontalSignalingId) return SignalingTypeEnum.Horizontal;
    return SignalingTypeEnum.Device;
  }

  // Abre o modal de reposicionamento para a sinalização clicada (imagem ou PDF).
  onPdfMarkerClick(event: { id?: string }) {
    if (!event?.id) return;
    this.openRepositionModal(this.pdfMasterById[event.id]);
  }

  openRepositionModal(master: any) {
    if (!master) return;
    this.repositionMaster = master;
    this.repositionSignType = this.getSignTypeFromMaster(master);
    this.repositionSignSvg = master['__svg'];
    this.repositionSignCode = master['__signCode'] || '';
    this.repositionReferences = this.masterSigns
      .filter((m) => m !== master && m['__svg'] && m.locations?.length)
      .map((m) => ({ locations: m.locations, svg: m['__svg'] }));
    this.repositionData = master;
    this.repositionModalRef = this._modalService.show(this.repositionModal, {
      class: 'modal-dialog-centered modal-xl',
      backdrop: 'static',
    });
  }

  // Recebe as coordenadas emitidas pelo app-master-file.
  receiveReposition(event: any) {
    this.repositionData = event;
  }

  confirmReposition() {
    const data = this.repositionData;
    const hasLocation = data?.locations?.[0]?.pointA?.x != null;
    if (!hasLocation) {
      this.repositionModalRef?.hide();
      return;
    }
    data.projectFileId = data.projectFileId || this.repositionMaster?.projectFileId;
    const signId = this.repositionMaster?.verticalSignalingId
      ?? this.repositionMaster?.horizontalSignalingId
      ?? this.repositionMaster?.deviceSignalingId;
    const isUpdate = !!data.id;

    let obs;
    switch (this.repositionSignType) {
      case SignalingTypeEnum.Horizontal:
        obs = isUpdate
          ? this._projectService.updateHorizontalMasterFile(signId, data)
          : this._projectService.createHorizontalMasterFile(signId, data);
        break;
      case SignalingTypeEnum.Device:
        obs = isUpdate
          ? this._projectService.updateDeviceMasterFile(signId, data)
          : this._projectService.createDeviceMasterFile(signId, data);
        break;
      default:
        obs = isUpdate
          ? this._projectService.updateVerticalMasterFile(signId, data)
          : this._projectService.createVerticalMasterFile(signId, data);
    }

    obs.subscribe(
      () => {
        // Atualiza o registro em memória e recalcula o overlay.
        this.repositionMaster.locations = data.locations;
        this.refreshMasterFileOverlay();
        this.repositionModalRef?.hide();
        this._toastService.showSuccess('Posição atualizada com sucesso!');
      },
      () => this._toastService.showError('Não foi possível atualizar a posição.'),
    );
  }

  closeReposition() {
    this.repositionModalRef?.hide();
  }

  // Abre a confirmação antes de remover o marcador (delete é destrutivo/permanente).
  confirmRemoveMarker(template: TemplateRef<any>) {
    this.openModal(template);
  }

  // Remove o posicionamento (marcador) da sinalização no arquivo-mestre.
  removeMarker() {
    this.modalRef?.hide();

    const master = this.repositionMaster;
    // Sem id significa que ainda não foi salvo no back — só limpa localmente.
    if (!master?.id) {
      this.removeMasterFromState(master);
      this.repositionModalRef?.hide();
      return;
    }
    const signId = master?.verticalSignalingId
      ?? master?.horizontalSignalingId
      ?? master?.deviceSignalingId;

    let obs;
    switch (this.repositionSignType) {
      case SignalingTypeEnum.Horizontal:
        obs = this._projectService.deleteHorizontalMasterFile(signId, master.id);
        break;
      case SignalingTypeEnum.Device:
        obs = this._projectService.deleteDeviceMasterFile(signId, master.id);
        break;
      default:
        obs = this._projectService.deleteVerticalMasterFile(signId, master.id);
    }

    obs.subscribe(
      () => {
        this.removeMasterFromState(master);
        this.repositionModalRef?.hide();
        this._toastService.showSuccess('Marcador removido do arquivo-mestre.');
      },
      () => this._toastService.showError('Não foi possível remover o marcador.'),
    );
  }

  // Tira a sinalização da lista de marcadores e recalcula o overlay.
  private removeMasterFromState(master: any) {
    this.masterSigns = this.masterSigns.filter((m) => m !== master);
    if (master?.id && this.pdfMasterById[master.id]) delete this.pdfMasterById[master.id];
    this.refreshMasterFileOverlay();
  }

  // Recalcula os marcadores do overlay a partir de masterSigns.
  private refreshMasterFileOverlay() {
    this.pointsList = [];
    this.pdfPointsList = [];
    this.pdfLinesList = [];
    this.pdfMasterById = {};
    this.masterSigns.forEach((master) => this.GetMarkers(master));
  }

  onMasterImgLoad() {
    this.masterImgLoaded = true;
  }

  zoomMasterIn() {
    this.masterImageZoom = Math.min(+(this.masterImageZoom + this._zoomStep).toFixed(2), this._zoomMax);
  }

  zoomMasterOut() {
    this.masterImageZoom = Math.max(+(this.masterImageZoom - this._zoomStep).toFixed(2), this._zoomMin);
  }

  resetMasterZoom() {
    this.masterImageZoom = 1;
  }

  // Ctrl + wheel: zoom; sem Ctrl: deixa o scroll normal acontecer.
  onMasterWheel(event: WheelEvent) {
    if (!event.ctrlKey) return;
    event.preventDefault();
    if (event.deltaY < 0) this.zoomMasterIn();
    else this.zoomMasterOut();
  }

  onMasterPanStart(event: MouseEvent, container: HTMLElement) {
    if (this.isMasterFilePdf) return;
    // Não inicia pan ao clicar nos botões de zoom ou em algum marcador.
    const target = event.target as HTMLElement | null;
    if (target?.closest('.master-file-zoom-controls')) return;
    if (target?.closest('.master-marker')) return;
    if (event.button !== 0) return; // só com botão esquerdo

    this.isPanningMaster = true;
    this._panStartX = event.clientX;
    this._panStartY = event.clientY;
    this._panScrollLeft = container.scrollLeft;
    this._panScrollTop = container.scrollTop;
    event.preventDefault(); // evita drag nativo da imagem
  }

  onMasterPanMove(event: MouseEvent, container: HTMLElement) {
    if (!this.isPanningMaster) return;
    container.scrollLeft = this._panScrollLeft - (event.clientX - this._panStartX);
    container.scrollTop = this._panScrollTop - (event.clientY - this._panStartY);
  }

  onMasterPanEnd() {
    this.isPanningMaster = false;
  }

  //Obter Posição do Ponto Sobre o Arquivo Mestre
  GetMarkerPosition(div: any, marker: any) {
    //Dimensões da Div
    const divWidth = div.offsetWidth;
    const divHeight = div.offsetHeight;

    //Dimensões da Imagem Original
    const fileWidth = marker.fileDimensions.split('x')[0];
    const fileHeight = marker.fileDimensions.split('x')[1];

    //Escalas
    const xScale = divWidth / fileWidth;
    const yScale = divHeight / fileHeight;
    let scale = 0;
    let xOffset = 0;
    let yOffset = 0;

    //Determinar Offset
    if (xScale > yScale) {
      scale = xScale;
      yOffset = (divHeight - fileHeight * scale) / 2;
    } else {
      scale = yScale;
      xOffset = (divWidth - fileWidth * scale) / 2;
    }

    //Retornar Distância Proporcional
    let top = marker.posY * scale + yOffset;
    top -= 15; //Ícone Possui 30px de Altura

    let left = marker.posX * scale + xOffset;
    left -= 15; //Ícone Possui 30px de Largura

    return `top: ${top}px; left: ${left}px;`;
  }

  sendToTask() {
    // Os filtros por tipo só existem na opção "Tarefa Independente"; nas outras vão todas as sinalizações
    const filterByType = this.modalSelectedOption == 1;
    const sendVertical = !filterByType || this.modalCheckState.vertical;
    const list = {
      vertical: JSON.stringify(sendVertical ? this.modalSignList.projectTrafficSigns : []),
      horizontal: JSON.stringify(!filterByType || this.modalCheckState.horizontal ? this.modalSignList.projectHorizontalSignalings : []),
      device: JSON.stringify(!filterByType || this.modalCheckState.device ? this.modalSignList.projectDeviceSignalings : []),
    };
    const supports = JSON.stringify(sendVertical ? this.modalSignList.projectSupports : []);

    const type = TaskTypeEnum.Implantation;
    const projectId = this.projectBody.id;
    const contractId = this.projectBody.contractId;
    const send = JSON.stringify({ type, list, projectId, contractId, supports });

    localStorage.setItem('signsCatalog', send);

    if (this.modalSelectedOption == 0) {
      this._router.navigate(['/services/order/new']);
    } else if (this.modalSelectedOption == 1) {
      this._router.navigate(['/services/tasks']);
    } else if (this.modalSelectedOption == 2) {
      this._router.navigate([`services/order/new/${this.selectedServiceOrderId}`]);
    }
  }

  removeSignFromModal(arr: any[], index: number) {
    arr.splice(index, 1);
  }

  createMapModal() {
    this.mapModal = this._map.initMap('project-modal-map');
    this._map.initLayer(this.mapModal, this.layerModal);
    this.signs = {
      vertical: new Set(),
      horizontal: new Set(),
      device: new Set(),
    };
    this.getSigns(this.layerModal);
  }

  handleSignCodeEmit(event, isMap?, type?: 'vertical' | 'device' | 'horizontal') {
    this.modalSignFilterCode = event == this.modalSignFilterCode ? null : event;
    if (isMap && this.modalSignFilterCode) {
      this.filterMap(event, type);
    }
  }

  filterMap(signCode, type) {
    this.layerModal.clearLayers();
    this.signs[type].forEach((sign) => {
      this.addMarker(sign, this.layerModal);
    });
  }

  dismantleActivitiesProject() {
    this.processSignaling(
      this.projectBody.projectTrafficSigns,
      "projectTrafficSigns",
      ProjectTrafficSign
    );
    this.processSignaling(
      this.projectBody.projectHorizontalSignalings,
      "projectHorizontalSignalings",
      ProjectHorizontalSignaling
    );
  }

  processSignaling(signings, signalingListName, ClassType) {
    const processedSignings: Array<any> = [];
    signings.forEach(signing => {
      const { activitiesList, ...rest } = signing;
      if (signing?.activitiesList?.length) {
        // Atividades que não tem lat e lng e se juntam no final
        const signingWithQuantity = new ClassType({ ...rest });
        signingWithQuantity.quantity = 0;

        signing?.activitiesList?.forEach(activity => {
          if (activity.latlngForm) {
            const clonedSigning = new ClassType({ ...rest });
            clonedSigning.quantity = 1;
            clonedSigning.latitude = activity.latitude;
            clonedSigning.longitude = activity.longitude;
            processedSignings.push(clonedSigning);
          } else {
            signingWithQuantity.quantity += 1;
          }
        });

        if (signingWithQuantity.quantity > 0) {
          processedSignings.push(signingWithQuantity);
        }
      } else if (signing?.latitude && signing?.longitude) {
        processedSignings.push(new ClassType({ ...rest }))
      } else if (signing?.quantity > 0) {
        processedSignings.push(new ClassType({ ...rest }))
      }
    });

    this.projectBody[signalingListName] = processedSignings;
  }

  addProjectHorizontalSignalingMarker(projectHorizontalSignaling: ProjectHorizontalSignaling) {
    this._map.addProjectHorizontalSignalingMarker(projectHorizontalSignaling, this.layerProjectsSignalings);
  };

  addProjectDeviceSignalingMarker(projectDeviceSignaling: ProjectDeviceSignaling) {
    projectDeviceSignaling.locations.forEach((element, index) => {
      this._map.addProjectDeviceSignalingMarker(projectDeviceSignaling, this.layerProjectsSignalings, index);
    });
  };

  addProjectTrafficSignMarker(projectTrafficSign: ProjectTrafficSign) {
    this._map.addProjectTrafficSignMarker(projectTrafficSign, this.layerProjectsSignalings);
  };

  // Centraliza o mapa na sinalização escolhida na lista
  centralizeMap(coordinates): void {
    // Verifique se há coordenadas para criar o bounds
    if (coordinates.length > 0) {
      const bounds = Leaflet.latLngBounds(coordinates);
      this.map.fitBounds(bounds); // Ajusta o mapa ao bounds
    }
  }

  setProjectGroupSigns(items: any[]): any[] {
    const grouped = new Map<string, { quantity: number; quantityRegistered: number; cost: number; coordinates: { latitude: number; longitude: number }[] }>();

    // Chave de agrupamento ignora campos que escalam por sinalização (quantity,
    // quantityRegistered, cost) e os que são únicos por linha (id, lat/lng).
    // Se cost ficasse na chave, dois itens iguais seriam agrupados mas o cost do
    // baseItem seria preservado em vez de somado, fazendo Valor Unitário
    // (cost/quantity) virar metade quando 2 itens iguais são fundidos.
    const excludedKeys = new Set(["latitude", "longitude", "quantity", "quantityRegistered", "cost", "id"]);

    for (const item of items) {
      const keyObject: { [key: string]: any } = {};
      for (const [key, value] of Object.entries(item)) {
        if (!excludedKeys.has(key)) keyObject[key] = value;
      }
      const key = JSON.stringify(keyObject);

      if (!grouped.has(key)) {
        grouped.set(key, { quantity: 0, coordinates: [], quantityRegistered: 0, cost: 0 });
      }

      const group = grouped.get(key)!;
      group.quantity += item.quantity ?? 0;
      group.quantityRegistered += item.quantityRegistered ?? 0;
      group.cost += item.cost ?? 0;
      group.coordinates.push({ latitude: item.latitude, longitude: item.longitude });
    }


    return Array.from(grouped.entries()).map(([key, group]) => {
      const baseItem = JSON.parse(key);
      return {
        ...baseItem,
        quantity: group.quantity,
        coordinates: group.coordinates,
        quantityRegistered: group.quantityRegistered,
        cost: group.cost,
      };
    });
  }


}
